var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "search-icon_svg__Ebene_2_00000113349599625228518620000012419780355575562660_",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 26.8 26.8",
  style: {
    enableBackground: "new 0 0 26.8 26.8"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".search-icon_svg__st0{fill:none;stroke:#333;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "search-icon_svg__Gruppe_20751"
}, /*#__PURE__*/React.createElement("g", {
  id: "search-icon_svg__Gruppe_243"
}, /*#__PURE__*/React.createElement("path", {
  id: "search-icon_svg__Ellipse_7-2",
  className: "search-icon_svg__st0",
  d: "M19.2 19.3c-4.2 4.2-10.9 4.2-15.1 0S-.2 8.2 4 4 15-.2 19.2 4c2 2 3.2 4.8 3.2 7.6v.1c0 2.9-1.1 5.6-3.2 7.6z"
}), /*#__PURE__*/React.createElement("path", {
  id: "search-icon_svg__Linie_18",
  className: "search-icon_svg__st0",
  d: "m25.9 25.9-6.6-6.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "search-icon_svg__Ellipse_7-3",
  className: "search-icon_svg__st0",
  d: "M11.7 18.8c-3.9 0-7.1-3.2-7.1-7.1"
})))));
export default SvgSearchIcon;